import AutoShrinkText, { AutoShrinkTextPlaceholder } from "./autoshrink"

import multiply from "../assets/multiply_bold.png"
import checkmark from "../assets/checkmark_bold.png"

import translations from "../translations";

import { motion } from "framer-motion"
import { UserImage } from "../pages/quiz";

function emojiAndText(option) {
    const s = (option ?? "").trim();
    if (!s) return { emoji: "", text: "" };
  
    const re = /^(?<emoji>(?:\p{Extended_Pictographic}(?:\uFE0F|\u200D\p{Extended_Pictographic})*))\s*(?<text>.*)$/u;
    const m = s.match(re);
  
    if (!m || !m.groups) return { emoji: "", text: s };
    return { emoji: m.groups.emoji ?? "", text: (m.groups.text ?? "").trim() };
  }

export default function QuestionCard(props) {

    let question = props.question
    let name = props.name

    let index = props.index
    let inputRef = props.inputRef
    let isFocused = props.isFocused
    let text = props.text

    let cardTexts = props.cardTexts
    let setCardTexts = props.setCardTexts

    let result = props.result

    let answerByAbout = props.answerByAbout

    let answersName = props.answersName
    let gameMode = props.gameMode

    let lang = props.lang

    let hasApp = props.hasApp

    let currentIndex = props.currentIndex

    const handleClick = () => {
        inputRef?.current?.focus();
    };

    return (
        <div className={(question.answerType == "text" || question.answerType == "emoji") ? "question-card" : "question-card background-primary"}
            
        >
            <div className={"question-card__top " + question.category}>
                {gameMode != "tel" && gameMode != "tot" && <motion.div className="question-card__top__emoji">{question.emoji}</motion.div>}
                <motion.div>{name != null && question.userText(name, lang) != "" ? question.userText(name, lang) : question.text(lang)}</motion.div>
                {question.category == "custom" && <div className="question-card__custom-hint">{(translations[lang] || translations.en).customHint(name)}</div>}
            </div>
            <motion.div className="question-card__mid"
                
            >
                {
                    (question.answerType == "text" || question.answerType == "emoji") && 
                    <div className="question-card__mid__type" 
                    onClick={() => handleClick()}
                >
                    <div className="question-card__mid__type_top">
                    <div className="question-card__mid__type__text"><AutoShrinkText text={text} /></div>
                        {text == "" && gameMode == "friend" && index == 0 && currentIndex == 0 && <div className="question-card__mid__type__placeholder"><AutoShrinkTextPlaceholder texts={[(translations[lang] || translations.en).justGuess].concat(question?.options?.(lang)?.length ? question.options(lang) : ["??"])} /></div>}
                        {
                            result != null ? <div className={result ? "checkbox_correct" : "checkbox_wrong"}><img src={result ? checkmark : multiply} /></div> :
                        isFocused ? <div className={"question-card__mid__type_indicator " + question.category}></div> : <div className="question-card__mid__type_indicator"></div>
                        }
                    </div>
                    <div className="question-card__mid__type_bot"></div>
                    {gameMode == "tel" && result != null && answerByAbout != null && answerByAbout.length > 0 && <div className="qcinbtm">{name}: {answerByAbout}</div>}
                </div>
                }
                {
                    question.answerType == "pickUser" &&
                    <div className="question-card__mid__pick">
                        <motion.div className={text == "0" ? result != null ? result ? "question-card__mid__pick__cell correct-border" : "question-card__mid__pick__cell wrong-border" : `question-card__mid__pick__cell ${gameMode}-border` : "question-card__mid__pick__cell"} onClick={() => {
                            if (cardTexts != null && result == null) {
                                const newTexts = [...cardTexts];
                                newTexts[index] = "0";
                                setCardTexts(newTexts)
                            }
                        }}
                        whileTap={{
                            scale: cardTexts != null && result == null ? 0.96 : 1
                        }}
                        >
                            {name}
                            {result != null &&
                                <div className="question-card__mid__pick__selection">
                                    {text == "0" && <UserImage size={23} name={name} />}
                                    {answerByAbout != null && answerByAbout == "0" && <UserImage size={23} name={answersName} />}
                                </div>
                            }
                        </motion.div>
                        <motion.div className={text == "1" ? result != null ? result ? "question-card__mid__pick__cell correct-border" : "question-card__mid__pick__cell wrong-border" : `question-card__mid__pick__cell ${gameMode}-border` : "question-card__mid__pick__cell"} onClick={() => {
                            if (cardTexts != null && result == null) {
                                const newTexts = [...cardTexts];
                                newTexts[index] = "1";
                                setCardTexts(newTexts)
                            }
                        }}
                        whileTap={{
                            scale: cardTexts != null && result == null ? 0.96 : 1
                        }}
                        >
                            {answersName}
                            {result != null &&
                                <div className="question-card__mid__pick__selection">
                                    {text == "1" && <UserImage size={23} name={name} />}
                                    {answerByAbout != null && answerByAbout == "1" && <UserImage size={23} name={answersName} />}
                                </div>
                            }
                        </motion.div>
                    </div>
                }
                {
                    question.answerType == "thisOrThat" &&
                    <div className="question-card__mid__pick">
                        <motion.div className={text == "0" ? result != null ? result ? "question-card__mid__pick__cell correct-border" : "question-card__mid__pick__cell wrong-border" : `question-card__mid__pick__cell ${gameMode}-border` : "question-card__mid__pick__cell"} onClick={() => {
                            if (cardTexts != null && result == null) {
                                const newTexts = [...cardTexts];
                                newTexts[index] = "0";
                                setCardTexts(newTexts)
                            }
                        }}
                        whileTap={{
                            scale: cardTexts != null && result == null ? 0.96 : 1
                        }}
                        >
                            <div>{emojiAndText(question.options(lang)[0]).emoji}</div>
                            <div>{emojiAndText(question.options(lang)[0]).text}</div>
                        </motion.div>
                        <motion.div className={text == "1" ? result != null ? result ? "question-card__mid__pick__cell correct-border" : "question-card__mid__pick__cell wrong-border" : `question-card__mid__pick__cell ${gameMode}-border` : "question-card__mid__pick__cell"} onClick={() => {
                            if (cardTexts != null && result == null) {
                                const newTexts = [...cardTexts];
                                newTexts[index] = "1";
                                setCardTexts(newTexts)
                            }
                        }}
                        whileTap={{
                            scale: cardTexts != null && result == null ? 0.96 : 1
                        }}
                        >
                            <div>{emojiAndText(question.options(lang)[1]).emoji}</div>
                            <div>{emojiAndText(question.options(lang)[1]).text}</div>
                        </motion.div>
                    </div>
                }
            </motion.div>
            <motion.div className={question.answerType == "pickUser" || question.answerType == "thisOrThat" ? "question-card__fot qcfotwoy" : "question-card__fot"}
                
            >
                <div></div>
                <div>
                {`${index + 1}/10`}
                </div>
            </motion.div>

        </div>
    );
}